import { render, staticRenderFns } from "./inspectionHighRiskCount.vue?vue&type=template&id=10366f4c&scoped=true"
import script from "./inspectionHighRiskCount.vue?vue&type=script&lang=js"
export * from "./inspectionHighRiskCount.vue?vue&type=script&lang=js"
import style0 from "./inspectionHighRiskCount.vue?vue&type=style&index=0&id=10366f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10366f4c",
  null
  
)

export default component.exports